
export const formatPeriod = (iso) => {
  try {
    const date = new Date(iso);
    return date.toLocaleDateString("pt-BR", {
      month: "short",
      year: "numeric",
    });
  } catch (e) {
    return "Data inválida";
  }
};

export const formatValue = (value, unit) => {
  if (!value && value !== 0) return "N/A";

  try {
    const numValue = parseFloat(value);
    if (isNaN(numValue)) return "N/A";

    switch (unit) {
      case "R$":
        return new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(numValue);
      case "%":
        return `${numValue.toFixed(1)}%`;
      case "Score":
        return `${numValue.toFixed(1)}`;
      default:
        return `${numValue.toFixed(1)} ${unit || ""}`.trim();
    }
  } catch (e) {
    return "Erro";
  }
};

export const perfColor = (actual, target, higherIsBetter = true) => {
  const percentage = perfPct(actual, target, higherIsBetter);

  if (percentage >= 100) return 'bg-green-100 text-green-800';
  if (percentage >= 80) return 'bg-yellow-100 text-yellow-800';
  return 'bg-red-100 text-red-800';
};

export const perfIcon = (actual, target, higherIsBetter = true) => {
  const percentage = perfPct(actual, target, higherIsBetter);

  if (percentage >= 100) return 'trending-up';
  if (percentage < 80) return 'trending-down';
  return null;
};

export const perfPct = (actual, target, higherIsBetter = true) => {
  // Nulos/undefined
  if (actual == null || target == null) return null;

  // Normaliza -0
  if (Object.is(actual, -0)) actual = 0;
  if (Object.is(target, -0)) target = 0;

  /* =========================
     META = 0 (caso especial)
     ========================= */

  // MENOR = MELHOR (F): meta 0 => 0 é perfeito, >0 falhou
  if (target === 0 && !higherIsBetter) {
    if (actual === 0) return 100;
    if (actual > 0) return 0;
    // se actual < 0, o CASE não definiu explicitamente; cai no ELSE/NULL.
    return null;
  }

  // MAIOR = MELHOR (T): meta 0 => >0 atingiu, 0 não andou, <0 piorou
  if (target === 0 && higherIsBetter) {
    if (actual > 0) return 100;
    if (actual === 0) return 0;
    if (actual < 0) return -100;
  }

  /* =========================
     MAIOR = MELHOR (T)
     ========================= */
  if (higherIsBetter) {
    // I.HIGHER_IS_BETTER = 'T' AND V.ACTUAL = 0 THEN 0.0
    if (actual === 0) return 0;

    // ambos positivos
    if (actual > 0 && target > 0) {
      return Math.round((actual / target) * 100);
    }

    // meta positiva, realizado negativo => atingimento negativo
    if (actual < 0 && target > 0) {
      return Math.round(-(Math.abs(actual) / target) * 100);
    }

    // meta negativa, realizado positivo => regra A (soma magnitudes / magnitude meta)
    if (actual > 0 && target < 0) {
      return Math.round(((Math.abs(actual) + Math.abs(target)) / Math.abs(target)) * 100);
    }

    // ambos negativos (quanto mais perto de zero, melhor)
    if (actual < 0 && target < 0) {
      return Math.round((Math.abs(target) / Math.abs(actual)) * 100);
    }

    return null;
  }

  /* =========================
     MENOR = MELHOR (F)
     ========================= */
  // I.HIGHER_IS_BETTER = 'F' AND V.ACTUAL = 0 THEN 100.0
  if (actual === 0) return 100;

  // regra clássica: WHEN ... V.ACTUAL <> 0 THEN (V.TARGET / V.ACTUAL) * 100.0
  if (actual !== 0) {
    return Math.round((target / actual) * 100);
  }

  return null;
};

export const getPerspectiveIcon = (perspective) => {
  const icons = {
    "Financial Reports": "dollar-sign",
    "Customer Surveys": "users",
  };
  return icons[perspective] || "bar-chart-3";
};
